import '../index.css';
import { Component } from 'react';
import { LockFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Col } from 'antd';
import UserLogin from './userLogin';
import PolicyholderCheckLogin from './policyholderCheckLogin';
import SimplePage from '../../home/simplePage';

interface ILoginState {
    loginName: "PolicyholderLogin" | "UserLogin";
}

export interface ILoginProp {

}

export default class Login extends Component<ILoginProp, ILoginState> {
    constructor(props: ILoginProp) {
        super(props)
        let loginName = localStorage.getItem("LoginName");
        if (loginName !== "PolicyholderLogin" && loginName !== "UserLogin") {
            localStorage.setItem("LoginName", "PolicyholderLogin");
            loginName = "PolicyholderLogin";
        }
        this.state = {
            loginName: loginName as "PolicyholderLogin" | "UserLogin"
        }
    }
    componentDidMount() {
        //const { cookieEnabled } = navigator;
        //if (!cookieEnabled) {
        //    Modal.warn({
        //        title: 'تنظیمات کوکی ها',
        //        content: 'مرورگر شما، دسترسی به کوکی ها را مسدود کرده است. لطفا اجازه لازم را جهت اجرای سایت اعمال بفرمایید .',
        //        centered: true,
        //        autoFocusButton: 'ok',
        //        direction: 'rtl',
        //        okText: 'باشه'
        //    });
        //}
        let container = document.getElementById("container");
        if (container && !container.classList.contains("custom-scroll")) {
            container.style.overflow = "auto";
            container.classList.add("custom-scroll");
        }
    }
    componentWillUnmount() {
        let container = document.getElementById("container");
        if (container && container.classList.contains("custom-scroll")) {
            container.style.overflow = "hidden";
            container.classList.remove("custom-scroll");
        }
    }
    render() {
        const renderSwitch = () => {

            switch (this.state.loginName) {
                case "UserLogin":
                    return <UserLogin />;
                case "PolicyholderLogin":
                default:
                    return <PolicyholderCheckLogin />;
            }
        };

        const extraHeaderCols = (
            <Col span={10}>
                <Link className={'login-link'} to={"#"} style={{ float: 'left', marginLeft: 10 }} onClick={e => {
                    e.stopPropagation();
                    const loginName = this.state.loginName === "PolicyholderLogin" ? "UserLogin" : "PolicyholderLogin";
                    localStorage.setItem("LoginName", loginName);
                    this.setState({ loginName });
                }}>
                    <LockFilled style={{ marginLeft: 5 }} />
                    <span>{this.state.loginName === "PolicyholderLogin" ? "ورود کاربران ستادی" : "ورود بیمه گزار/مشتری"}</span>
                </Link>
            </Col>
        );

        return (
            <SimplePage extraHeaderCols={extraHeaderCols} >
                {renderSwitch()}
            </SimplePage>
        );
    }
};

